import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/invest_audit";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
}
